import { Box, Typography, useTheme } from "@material-ui/core";
import React from "react";
import config from "../../config";

interface IProps {
  content?: string;
}

const EmptyComponent: React.FC<IProps> = ({ content }) => {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexGrow={1}
      flexDirection="column"
    >
      <img
        src={config.VECTOR_AI_LOGO}
        height={100}
        width={100}
        alt="vectorai-logo"
      />
      <Typography
        variant="h5"
        style={{
          color: theme.palette.secondary.light,
          marginTop: theme.spacing(2),
        }}
        align="center"
      >
        {content}
      </Typography>
    </Box>
  );
};

EmptyComponent.defaultProps = {
  content: " 404 Page Not Found.",
};

export default EmptyComponent;
